import { render } from "./PlayAlongsPlayer.vue?vue&type=template&id=f2193fda"
import script from "./PlayAlongsPlayer.vue?vue&type=script&lang=js"
export * from "./PlayAlongsPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__